import { render, staticRenderFns } from "./WorkForm.vue?vue&type=template&id=6b41888f&"
import script from "./WorkForm.vue?vue&type=script&lang=js&"
export * from "./WorkForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports